export default __webpack_public_path__ + "static/media/img11.45cbf688.jpg";